import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import downArrow from "../../../assets/icons/arrows/chevron-down.svg";

const sortByDropDown = (props) => {
  const columns = props.isComment
    ? ["All", "Attachment"]
    : ["A-Z", "Z-A", "Last Modified", "First Modified"];
  const sortButton = React.forwardRef(({ onClick }, ref) => (
    <button
      className="btn-dropdown btn-sort"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      style={{ whiteSpace: "nowrap" }}
    >
      Sort By: {props.selectedColumn}
      <img
        className="ml-1 mr-0"
        width="12"
        height="12"
        src={downArrow}
        alt="arrowDown"
      />
    </button>
  ));

  return (
    <div className="dropdown sortBy-dropdown pr-3">
      <Dropdown alignRight className="ml-auto">
        <Dropdown.Toggle as={sortButton}></Dropdown.Toggle>
        <Dropdown.Menu>
          {columns.map((item, index) => (
            <Dropdown.Item
              as="a"
              key={index}
              className={props.selectedColumn === item ? "selected" : ""}
              onClick={() => props.sortColumnHandler(item)}
            >
              {item}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default sortByDropDown;
